import FacebookContext from 'contexts/FacebookContext';
import FacebookWrapper from './FacebookWrapper';

const FacebookContextConsumer = FacebookContext.Consumer;

export default FacebookContext;
export { FacebookContextConsumer, FacebookWrapper };
